import { Button } from '@music-vine/cadence/ui';
import PartnerButton from './PartnerButton';
const Hero = () => {
  return <header className="xl:special-page-container mt-[60px] mb-5 flex flex-col gap-9 md:ml-[clamp(1rem,8vw,60px)] md:flex-row md:gap-6 xl:mt-[120px] xl:mb-10 2xl:mb-[60px] 2xl:gap-10" data-sentry-component="Hero" data-sentry-source-file="Hero.tsx">
      <div className="w-full self-center max-md:px-container md:w-[55%]">
        <h1 className="mb-3 text-balance text-left font-bold text-5xl leading-none! tracking-[-1px] xl:text-6xl xl:tracking-[-3px] 2xl:text-7xl 2xl:tracking-[-3px] dark:text-white">
          Refer and earn with Uppbeat
        </h1>
        <p className="text-left text-gray-950 text-lg 2xl:text-xl dark:text-white">
          Share Uppbeat with your audience and earn 30% commission on every paid
          referral.
        </p>
        <div className="mt-5 flex flex-col gap-3 sm:flex-row">
          <PartnerButton className="max-sm:w-full" data-sentry-element="PartnerButton" data-sentry-source-file="Hero.tsx">
            Apply to become a partner
          </PartnerButton>
          <Button asChild border className="max-sm:w-full" size="lg" variant="subtle" data-sentry-element="Button" data-sentry-source-file="Hero.tsx">
            <a href="#how-it-works">How it works</a>
          </Button>
        </div>
      </div>
      <div className="w-full md:w-[calc(45%-24px)] 2xl:w-[calc(45%-40px)]">
        {/* Light mode image */}
        <picture className="dark:hidden" data-sentry-element="picture" data-sentry-source-file="Hero.tsx">
          <source media="(min-width: 1280px)" srcSet="https://cdn.uppbeat.io/images/refer-and-earn-hero-light-3-xl.jpg" />
          <source media="(min-width: 768px)" srcSet="https://cdn.uppbeat.io/images/refer-and-earn-hero-light-2-md.jpg" />
          <img alt="Montage of creators dancing, filming, and taking photos in colorful scenes." className="w-full object-contain object-center" src="https://cdn.uppbeat.io/images/refer-and-earn-hero-light-1-sm.jpg" />
        </picture>
        {/* Dark mode image */}
        <picture className="hidden dark:block" data-sentry-element="picture" data-sentry-source-file="Hero.tsx">
          <source media="(min-width: 1280px)" srcSet="https://cdn.uppbeat.io/images/refer-and-earn-hero-dark-3-xl.jpg" />
          <source media="(min-width: 768px)" srcSet="https://cdn.uppbeat.io/images/refer-and-earn-hero-dark-2-md.jpg" />
          <img alt="Montage of creators dancing, filming, and taking photos in colorful scenes." className="w-full object-contain object-center" src="https://cdn.uppbeat.io/images/refer-and-earn-hero-dark-1-sm.jpg" />
        </picture>
      </div>
    </header>;
};
export default Hero;